import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AmbientTicker from './AmbientTicker';
import QuickSettings from './QuickSettings';
import IdleChip from './IdleChip';
import { useAuth } from '../../hooks/useAuth';
import { useVisualSettings } from '../../hooks/useVisualSettings';

interface AppShellProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

const AppShell: React.FC<AppShellProps> = ({ children, showFooter = true }) => {
  const location = useLocation();
  const { authed } = useAuth();
  // Calling this here mounts the effect that syncs localStorage values to
  // the <html> data-* attributes on every route — so palette + fontset +
  // density + motion choices apply uniformly across public + authed pages.
  useVisualSettings();

  // Ambient bar only on authed app routes — public/login pages stay clean.
  const showAmbient = authed && location.pathname.startsWith('/app');

  return (
    <div className="gv-shell">
      {/* Top ambient bar is pinned to SPX for now — it's a fixed market
          reference, intentionally NOT following the searched/active ticker.
          Drop the `ticker` prop to restore hash-following behavior later. */}
      {showAmbient && <AmbientTicker ticker="SPX" />}
      <Header />
      <main className="gv-main">{children}</main>
      {showFooter && <Footer />}
      {/* Floating quick toggle on every authed page so users can re-skin
          without leaving the heatmap. */}
      {authed && <QuickSettings />}
      {/* Paused-stream chip. Self-gated to /app/* so public pages
          (which don't hold WebSockets) never show it. */}
      <IdleChip />
    </div>
  );
};

export default AppShell;
